import React, { Suspense, useEffect } from "react";

// Components
// Bootstrap
// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/dist/js/bootstrap.js";
// import $ from "jquery";

import Main from "./Routing";
import { Provider } from "react-redux";
import store from "./Redux/store";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faBars, faUser } from "@fortawesome/free-solid-svg-icons";
library.add(faBars, faUser);

function App() {
  return (
    <Provider store={store}>
      <Main />
    </Provider>
  );
}

export default App;
